
import { Helmet } from "react-helmet";

import MainLayout from "@/components/layout/MainLayout";
import GalleryFiltered from "@/components/GalleryFiltered"; // zamiast LazyGallery
import BackButton from "@/components/common/BackButton";

const Gallery = () => {
  return (
    <>
      <Helmet>
        <title>Galeria Detailing Poznań Wilda | Efekty Pracy | 061 Garage</title>
        <meta 
          name="description" 
          content="Zobacz galerię efektów detailingu 061 Garage Poznań Wilda. Przed i po myciu, praniu tapicerki. Profesjonalne rezultaty. Umów się: 602 709 327" 
        />
        <meta name="keywords" content="galeria detailing Poznań Wilda, efekty pracy detailing, przed i po detailing Poznań, zdjęcia mycia aut, portfolio 061 garage" />
        <link rel="canonical" href="https://061garagedetailingstudio.pl/galeria" />
        <meta property="og:title" content="Galeria Detailing Poznań Wilda | Efekty Pracy | 061 Garage" />
        <meta property="og:description" content="Zobacz spektakularne efekty detailingu Poznań Wilda - przed i po czyszczeniu. Profesjonalny serwis. Zadzwoń: 602 709 327" />
        <meta property="og:url" content="https://061garagedetailingstudio.pl/galeria" />
        <meta property="og:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="061 Garage Detailing Studio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Galeria Detailing Poznań Wilda | Efekty Pracy | 061 Garage" />
        <meta name="twitter:description" content="Zobacz spektakularne efekty detailingu Poznań Wilda - przed i po czyszczeniu. Profesjonalny serwis. Zadzwoń: 602 709 327" />
        <meta name="twitter:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ImageGallery",
            "name": "Galeria prac detailingowych 061 Garage",
            "description": "Galeria efektów pracy detailingowej w Poznaniu",
            "provider": {
              "@type": "LocalBusiness",
              "name": "061 Garage Detailing Studio"
            }
          })}
        </script>
      </Helmet>
      <BackButton />
      <MainLayout>
        <div className="pt-24 md:pt-28">
          <GalleryFiltered /> {/* Bezpośredni import zamiast LazyGallery */}
        </div>
      </MainLayout>
    </>
  );
};

export default Gallery;
